/**
 * Get nested value from object by dot path (e.g. "beneficiary.bank_details.account_number")
 * @param {Object} obj
 * @param {string} path
 * @returns {*}
 */
export function deepGet(obj, path) {
  if (obj == null || path == null) return undefined;
  const keys = path.split('.');
  let current = obj;
  for (const key of keys) {
    if (current == null) return undefined;
    current = current[key];
  }
  return current;
}

/**
 * Set nested value in object by dot path. Mutates obj.
 * @param {Object} obj
 * @param {string} path
 * @param {*} value
 * @returns {Object} obj
 */
export function deepSet(obj, path, value) {
  if (obj == null || path == null) return obj;
  const keys = path.split('.');
  let current = obj;
  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    const nextKey = keys[i + 1];
    if (current[key] == null) {
      current[key] = String(Number(nextKey)) === nextKey ? [] : {};
    }
    current = current[key];
  }
  current[keys[keys.length - 1]] = value;
  return obj;
}

/**
 * Loại bỏ các key có value = null hoặc '' (rỗng) trong object (đệ quy).
 * Object rỗng sau khi xóa cũng bị loại.
 * @param {Object} obj
 * @returns {Object}
 */
export function removeEmptyKeys(obj) {
  if (obj === null || typeof obj !== 'object' || Array.isArray(obj)) return obj;
  const out = {};
  Object.keys(obj).forEach((key) => {
    const val = obj[key];
    if (val === null || val === '') return;
    if (typeof val === 'object' && !Array.isArray(val)) {
      const cleaned = removeEmptyKeys(val);
      if (Object.keys(cleaned).length > 0) out[key] = cleaned;
      return;
    }
    if (Array.isArray(val)) {
      out[key] = val;
      return;
    }
    out[key] = val;
  });
  return out;
}

/**
 * Field chọn currency (account_currency AirWallex, currency Wise) – dùng để set cứng theo currencyISO.
 * @param {{ path?: string, field?: { key?: string } }} item
 * @returns {boolean}
 */
export function isCurrencyField(item) {
  if (!item?.path) return false;
  const path = String(item.path).toLowerCase();
  const key = String(item.field?.key || '').toLowerCase();
  return path.includes('currency') || key === 'account_currency' || key === 'currency';
}
